export default __webpack_public_path__ + "static/media/gallery_02.2537c64a.jpg";